module.exports = __webpack_public_path__ + "static/media/default.41771dbd.jpeg";